// material-ui
import { SizeProps } from '../types/extended';
import Avatar from '../components/@extended/Avatar';
import { AppConfig } from '../config';
import { stringAvatar } from '../utils/avatar';
import { useEffect, useState } from 'react';

interface AssetLogoProps {
  logo: string | null | undefined;
  name: string | null | undefined;
  size: SizeProps;
  isPublic?: boolean;
}

interface ImageCache {
  [key: string]: string;
}

const imageCache: ImageCache = {};

export const loadImage = (src: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (imageCache[src]) {
      resolve(imageCache[src]);
    } else {
      const img = new Image();
      img.onload = () => {
        imageCache[src] = src;
        resolve(src);
      };
      img.onerror = reject;
      img.src = src;
    }
  });
};

const AssetLogo = ({ logo, name, size, isPublic }: AssetLogoProps) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    if (logo) {
      const fullSrc = `${AppConfig.apiRoot}files/${isPublic ? 'image-asset' : 'avatar'}/${logo}`;
      loadImage(fullSrc)
        .then(() => setImageSrc(fullSrc))
        .catch((error) => console.error('Error loading image:', error));
    }
  }, [logo, isPublic]);

  if (imageSrc) {
    return <Avatar alt={name || ''} src={imageSrc} size={size} sx={{ backgroundColor: 'transparent', objectFit: 'contain' }} />;
  }
  if (!logo) {
    return <Avatar alt={name || ''} {...stringAvatar(name || '')} size={size} />;
  }
  return null;
};

export default AssetLogo;
